import type { PaidCostParts } from "@loot-os/fulfillment-core/order/paid-above-charged";

import { centsToDollars } from "../lib/format";
import { PAID_COST_FIELDS } from "../lib/paidCosts";

/**
 * A line's paid cost on the order page: the item cost the move to PROCESSING stored, and under it
 * the StockX order page amounts it was entered as, labelled as the form labels them. A part left
 * out is not listed. A cost entered as one amount, or none yet, shows the amount or a dash.
 */
export function PaidCostCell({
  paidCostCents,
  paidCostParts,
}: {
  paidCostCents: number | null;
  paidCostParts: PaidCostParts | null;
}) {
  if (paidCostCents === null) return <>—</>;
  const listed = paidCostParts
    ? PAID_COST_FIELDS.flatMap((field) => {
        const cents = paidCostParts[field.key];
        return cents === undefined ? [] : [{ ...field, cents }];
      })
    : [];
  return (
    <div className="flex flex-col gap-0.5">
      <span>{centsToDollars(paidCostCents)}</span>
      {listed.length > 0 ? (
        <dl className="grid grid-cols-[auto_auto] gap-x-2 text-xs text-muted-foreground">
          {listed.map((field) => (
            <div key={field.key} className="contents">
              <dt>{field.label}</dt>
              <dd className="text-right">{centsToDollars(field.cents)}</dd>
            </div>
          ))}
        </dl>
      ) : null}
    </div>
  );
}
